/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import { FormControlLabel, Switch as MUISwitch } from '@material-ui/core';

interface Props {
  name: string;
  isChecked: boolean;
  label: string;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
}

const Switch: React.FC<Props> = (props) => {
  const { name, isChecked, label, onChange } = props;

  return (
    <FormControlLabel
      control={
        <MUISwitch
          name={name}
          checked={isChecked}
          onChange={onChange}
          color='primary'
        />
      }
      label={label}
    />
  );
};

export default Switch;
